import { createContext, useEffect } from 'react'
import { useApi } from 'hooks/useApi/useApi'

export const CountingContext = createContext()

export const CountingProvider = ({ children, countingId }) => {
    const {counting, fetchCounting, updateCounting, setCounting} = useApi()

    useEffect(() => {
        fetchCounting(countingId)
    }, [countingId])

    return (
        <CountingContext.Provider value={{counting, updateCounting, setCounting, fetchCounting}}>
            {children}
        </CountingContext.Provider>
    )
}

